import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isAfter, isBefore, startOfDay } from "date-fns";
import { Check, Refresh, Timelapse } from "mdi-material-ui";
import { Stack, Typography } from "@mui/material";
function index(props) {
    const { scheduledDate } = props;
    let artWork = isAfter(startOfDay(new Date(scheduledDate)), startOfDay(new Date()))
        ? {
            bgColor: "#FFEEDD",
            color: "#93591F",
            icon: Timelapse,
            status: "Upcoming Live",
        }
        : isBefore(startOfDay(new Date(scheduledDate)), startOfDay(new Date()))
            ? {
                bgColor: "rgba(61, 178, 128, 0.1)",
                color: "#3DB280",
                icon: Check,
                status: "Executed",
            }
            : {
                bgColor: "rgba(110, 96, 196, 0.1)",
                color: "#6E60C4",
                icon: Refresh,
                status: "In Progress",
            };
    const Icon = artWork.icon;
    return (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", spacing: 2, sx: { backgroundColor: artWork.bgColor, color: artWork.color, borderRadius: "20px", padding: "4px 12px" } }, { children: [_jsx(Icon, { sx: { color: "inherit", fontSize: "16px" } }), _jsx(Typography, Object.assign({ variant: "body2", sx: { color: "inherit" } }, { children: artWork.status }))] })));
}
export default index;
